import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import { getUrlFiles } from "../../../../utils/services/files";
import {
  postPaymentConfig,
  putPaymentConfig,
} from "../../../../utils/services/ticketeira";
import TextEditor from "../TextEditor";
import ModalViewDescription from "../Modals/ViewDescription";
import ModalViewDetails from "../Modals/ViewDetails";
import SweetAlert from "react-bootstrap-sweetalert";

// export const FormFieldsEditor = () => {
//   const [fields, setFields] = useState([
//     {
//       label: { pt: "" },
//       type: "text",
//       order: 1,
//       required: false,
//     },
//   ]);

//   const updateField = (index, key, value) => {
//     const updated = [...fields];
//     updated[index][key] = value;
//     setFields(updated);
//   };

//   const updateNestedField = (index, parentKey, nestedKey, value) => {
//     const updated = [...fields];
//     updated[index][parentKey] = {
//       ...updated[index][parentKey],
//       [nestedKey]: value,
//     };
//     setFields(updated);
//   };

//   const removeField = (index) => {
//     setFields(fields.filter((_, i) => i !== index));
//   };

//   const addNewField = () => {
//     setFields([
//       ...fields,
//       {
//         label: { pt: "" },
//         type: "text",
//         order: fields.length + 1,
//         required: false,
//       },
//     ]);
//   };

//   return (
//     <>
//       {fields.map((field, index) => (
//         <Row key={index} className="align-items-center mb-3">
//           <Col md="3">
//             <FormGroup className="mb-2">
//               <Label className="mb-1">Label (pt)</Label>
//               <Input
//                 type="text"
//                 value={field.label?.pt || ""}
//                 onChange={(e) =>
//                   updateNestedField(index, "label", "pt", e.target.value)
//                 }
//               />
//             </FormGroup>
//           </Col>

//           <Col md="3">
//             <FormGroup className="mb-2">
//               <Label className="mb-1">Tipo</Label>
//               <Input
//                 type="select"
//                 value={field.type}
//                 onChange={(e) => updateField(index, "type", e.target.value)}
//               >
//                 <option value="text">Texto</option>
//                 <option value="email">Email</option>
//                 <option value="number">Número</option>
//                 <option value="checkbox">Checkbox</option>
//                 <option value="cpf">CPF</option>
//                 <option value="mobile">Celular</option>
//                 <option value="state">Estado</option>
//                 <option value="city">Cidade</option>
//                 <option value="badge">Crachá</option>
//                 <option value="default">Campo Padrão</option>
//               </Input>
//             </FormGroup>
//           </Col>

//           <Col md="2">
//             <FormGroup className="mb-2">
//               <Label className="mb-1">Ordem</Label>
//               <Input
//                 type="number"
//                 value={field.order || 0}
//                 onChange={(e) =>
//                   updateField(index, "order", Number(e.target.value))
//                 }
//               />
//             </FormGroup>
//           </Col>

//           <Col md="2" className="d-flex align-items-center">
//             <FormGroup check className="d-flex align-items-center mb-0">
//               <Input
//                 type="checkbox"
//                 checked={field.required || false}
//                 onChange={(e) =>
//                   updateField(index, "required", e.target.checked)
//                 }
//               />
//               <Label check className="mb-0 ml-2">
//                 Obrigatório
//               </Label>
//             </FormGroup>
//           </Col>

//           <Col md="2" className="d-flex justify-content-end align-items-center">
//             <Button
//               color="link"
//               className="p-0 text-danger"
//               onClick={() => removeField(index)}
//             >
//               <i className="bi bi-trash" style={{ fontSize: "1.2rem" }}></i>
//             </Button>
//           </Col>

//           {field.required && (
//             <Col md="6" className="mt-2">
//               <FormGroup>
//                 <Label>Mensagem de Erro (pt)</Label>
//                 <Input
//                   type="text"
//                   value={field.error?.pt || ""}
//                   onChange={(e) =>
//                     updateNestedField(index, "error", "pt", e.target.value)
//                   }
//                 />
//               </FormGroup>
//             </Col>
//           )}

//           <Col md="12">
//             <hr className="mt-3 mb-3" />
//           </Col>
//         </Row>
//       ))}

//       <div className="text-center mt-4">
//         <Button color="secondary" onClick={addNewField}>
//           + Adicionar Campo
//         </Button>
//       </div>

//       <pre>{JSON.stringify(fields, null, 2)}</pre>
//     </>
//   );
// };

export const CheckoutSettingsTabs = ({
  activeTab,
  setActiveTab,
  formFields,
  setFormFields,
  paymentMethods,
  setPaymentMethods,
  headerImgUrl,
  setHeaderImgUrl,
  description,
  setDescription,
  details,
  setDetails,
  token,
  currentConfig,
  idEvent,
}) => {
  const [modalViewDetails, setModalViewDetails] = useState(false);
  const [modalViewDescription, setModalViewDescription] = useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [confirmSavedAlert, setConfirmSavedAlert] = useState(false);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const refDetails = useRef(null);
  const refDescription = useRef(null);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      alert(
        "Por favor, envie apenas imagens com os formatos JPEG, PNG ou WEBP."
      );
      event.target.value = null;
      return;
    }

    const maxSizeInMB = 3;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      alert(`A imagem deve ter no máximo ${maxSizeInMB}MB.`);
      return;
    }

    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await getUrlFiles(formData, null);

      if (response && response[0] && response[0].url) {
        const imageUrl = response;
        setHeaderImgUrl(imageUrl[0]?.url);
      } else {
        console.error("Erro ao enviar imagem:", response);
      }
    } catch (error) {
      console.error("Erro no upload:", error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      const multilingualDetails = {
        pt: details,
        en: details,
        es: details,
      };

      const multilingualDescription = {
        pt: description,
        en: description,
        es: description,
      };

      const body = {
        eventId: idEvent,
        headerImgUrl: headerImgUrl,
        details: JSON.stringify(multilingualDetails),
        description: JSON.stringify(multilingualDescription),
        fields: JSON.stringify(currentConfig.fields),
        language: JSON.stringify(currentConfig.language),
        creditCard: JSON.stringify(currentConfig.creditCard),
        email: JSON.stringify(currentConfig.email),
        pix: JSON.stringify(currentConfig.pix),
        customer: JSON.stringify(currentConfig.customer),
        promoCode: JSON.stringify(currentConfig.promoCode),
        errors: JSON.stringify(currentConfig.errors),
        messages: JSON.stringify(currentConfig.messages),
        buttons: JSON.stringify(currentConfig.buttons),
      };

      let response;

      if (currentConfig?.id) {
        response = await putPaymentConfig(token, currentConfig.id, body);
        setConfirmSavedAlert(true);
      } else {
        response = await postPaymentConfig(token, body);
        setConfirmSavedAlert(true);
      }
    } catch (error) {
      console.error("Erro ao salvar configuração:", error);
      alert("Erro ao salvar configuração.");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (currentConfig) {
      if (currentConfig.details) {
        const parsedDetails =
          typeof currentConfig.details === "string"
            ? JSON.parse(currentConfig.details)?.pt
            : currentConfig.details?.pt;

        if (parsedDetails) setDetails(parsedDetails);
      } else if (!details) {
        setDetails(`<div class="p-4">
          <h2 class="text-2xl font-bold mb-4">Informações do Evento</h2>
          <p class="mb-2"><strong>Local:</strong> Centro de Convenções</p>
          <p><strong>Horário:</strong> 18h às 22h</p>
        </div>`);
      }

      if (currentConfig.description) {
        const parsedDescription =
          typeof currentConfig.description === "string"
            ? JSON.parse(currentConfig.description)?.pt
            : currentConfig.description?.pt;

        if (parsedDescription) setDescription(parsedDescription);
      } else if (!description) {
        setDescription(`<div class="p-4 border-t mt-4">
          <p class="text-gray-700">
            Participe do nosso evento imobiliário e conheça lançamentos exclusivos e condições especiais.
          </p>
        </div>`);
      }
    }
  }, [currentConfig]);

  useEffect(() => {
    if (currentConfig?.headerImgUrl) {
      setHeaderImgUrl(currentConfig.headerImgUrl);
    } else {
      setHeaderImgUrl("");
    }
  }, [currentConfig]);

  return (
    <Col xl="12">
      <Card className="card-shadow">
        <CardBody>
          <CardTitle tag="h4">⚙️ Configurações do Checkout</CardTitle>

          <Nav tabs className="mt-4">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
                style={{ cursor: "pointer" }}
              >
                🛒 Carrinho
              </NavLink>
            </NavItem>

            {/* <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggle("2")}
                style={{ cursor: "pointer" }}
              >
                📝 Formulário
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggle("3")}
                style={{ cursor: "pointer" }}
              >
                💳 Pagamento
              </NavLink>
            </NavItem> */}
          </Nav>

          <TabContent activeTab={activeTab} className="pt-4">
            <TabPane tabId="1">
              <Form>
                <FormGroup>
                  <Label for="headerImgUrl">
                    Imagem de Cabeçalho (1300x300):
                  </Label>
                  <Input
                    type="file"
                    id="headerImgUrlUpload"
                    onChange={handleImageUpload}
                  />

                  {headerImgUrl && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={headerImgUrl}
                        alt="Preview"
                        style={{ maxWidth: "30%", height: "auto" }}
                      />
                    </div>
                  )}
                </FormGroup>
                <FormGroup>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <Label for="details">Detalhes:</Label>
                    <a
                      className="btn-view-email"
                      onClick={() => setModalViewDetails(true)}
                    >
                      Visualizar Detalhes
                      <i
                        className="mdi mdi-eye"
                        style={{
                          color: "#5084ff",
                          fontSize: 17,
                          cursor: "pointer",
                          marginLeft: 5,
                        }}
                      />
                    </a>
                  </div>
                  <div id="details">
                    <TextEditor
                      value={details}
                      onChange={setDetails}
                      refState={refDetails}
                    />
                  </div>
                </FormGroup>

                <FormGroup>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <Label for="description">Descrição:</Label>
                    <a
                      className="btn-view-email"
                      onClick={() => setModalViewDescription(true)}
                    >
                      Visualizar Descrição
                      <i
                        className="mdi mdi-eye"
                        style={{
                          color: "#5084ff",
                          fontSize: 17,
                          cursor: "pointer",
                          marginLeft: 5,
                        }}
                      />
                    </a>
                  </div>
                  <div id="description">
                    <TextEditor
                      value={description}
                      onChange={setDescription}
                      refState={refDescription}
                    />
                  </div>
                </FormGroup>
              </Form>
            </TabPane>

            {/* <TabPane tabId="2">
              <FormFieldsEditor fields={formFields} setFields={setFormFields} />
            </TabPane> */}

            {/* <TabPane tabId="3">
              <Form>
                {["pix", "credit_card"].map((methodKey) => (
                  <FormGroup check key={methodKey}>
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={!!paymentMethods[methodKey]}
                        onChange={(e) =>
                          setPaymentMethods({
                            ...paymentMethods,
                            [methodKey]: e.target.checked,
                          })
                        }
                            />
                      {methodKey === "pix" ? "PIX" : "Cartão de Crédito"}
                    </Label>
                  </FormGroup>
                ))}
              </Form>
            </TabPane> */}
          </TabContent>

          <Button
            color="primary"
            className="mt-4"
            onClick={(e) => handleSave(e)}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <Spinner size="sm" color="light" /> Salvando...
              </>
            ) : (
              "💾 Salvar Configurações"
            )}
          </Button>
        </CardBody>
      </Card>

      <ModalViewDetails
        isOpen={modalViewDetails}
        toggle={() => setModalViewDetails(false)}
        email={{ current: { getDetails: () => details } }}
      />
      <ModalViewDescription
        isOpen={modalViewDescription}
        toggle={() => setModalViewDescription(false)}
        email={{ current: { getDescription: () => description } }}
      />

      {confirmSavedAlert && (
        <SweetAlert
          success
          title="Configuração salva com sucesso!"
          confirmBtnText="OK"
          confirmBtnBsStyle="success"
          onConfirm={() => setConfirmSavedAlert(false)}
        >
          Suas alterações foram registradas.
        </SweetAlert>
      )}
    </Col>
  );
};
